import { TeamListItem } from '../types';
import { isUserDeprovisioned } from './teamStatus';

const statusCompare = (a: TeamListItem, b: TeamListItem): number => {
  if (!isUserDeprovisioned(a) && !isUserDeprovisioned(b)) {
    return 0;
  }

  return isUserDeprovisioned(a) ? 1 : -1;
};

export const teamListCompare = (itemA: TeamListItem, itemB: TeamListItem): number => {
  const fullNameA = `${itemA.profile.firstName} ${itemA.profile.lastName}`;
  const fullNameB = `${itemB.profile.firstName} ${itemB.profile.lastName}`;
  const fullNameCompare = fullNameA.localeCompare(fullNameB);

  const statusCompareResult = statusCompare(itemA, itemB);
  const compare = statusCompareResult === 0 ? fullNameCompare : statusCompareResult;

  return compare;
};
